export default __webpack_public_path__ + "static/media/gg.393e76fb.jpg";